import React from "react"
import {Menu, Transition} from "@headlessui/react";
import {HiOutlineDotsVertical} from "react-icons/hi";

interface IMenuDropProps {
    title?: string,
    children: any
}

const MenuDrop: React.FC<IMenuDropProps> = ({title = null, children}) => {
    return (
        <Menu as="div" className="relative inline-block">
            <div>
                <Menu.Button
                    className="inline-flex w-full justify-center rounded-lg px-4 py-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
                    {title && <span className={"text-center cursor-pointer"}>title</span>}
                    <HiOutlineDotsVertical className="w-6 h-6 text-gray-500 inline-block"/>
                </Menu.Button>
            </div>
            <Transition
                as={React.Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items
                    className="absolute z-50 left-[-20px] mt-1 py-1 w-48 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    {children}
                </Menu.Items>
            </Transition>
        </Menu>
    )
}

export default MenuDrop